import { useRef } from "react";
var useThrottle = function (ms) {
    var lastCall = useRef(0);
    return function () {
        var now = Date.now();
        if (now - lastCall.current < ms)
            return false;
        lastCall.current = now;
        return true;
    };
};
export default useThrottle;
